import {Component, Input} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {DialogInfoComponent} from "../../../../shared/dialog-info/dialog-info.component";
import {MatDialog} from "@angular/material/dialog";
import {MatExpansionPanel, MatExpansionPanelHeader} from "@angular/material/expansion";
@Component({
    selector: 'app-meta-data-onlyread',
  imports: [
    MatIcon,
    MatExpansionPanel,
    MatExpansionPanelHeader,
  ],
    templateUrl: './meta-data-onlyread.component.html',
    styleUrl: './meta-data-onlyread.component.scss',
  standalone: true
})
export class MetaDataOnlyreadComponent {

  @Input() value!: string | undefined;
  @Input() title!: string;

  constructor(private dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(DialogInfoComponent, {
      autoFocus: false,
      data: {title: this.title, value: this.value}
    });
  }

}
